import { CommandCategory, CommandCategoryConfig } from "./CommandPanel";
import { CommandItem } from "./types";

export const createNavigationCategories = (
  rootCategories: CommandCategoryConfig[],
): CommandCategoryConfig[] => {
  const navigation: CommandCategoryConfig[] = [];

  rootCategories.forEach((rootCategory) => {
    navigation.push(rootCategory);
  });

  return navigation;
};

interface GroupedItem {
  title: string;
  items: CommandItem[];
}

export const getGroupedItems = (
  selectedCategory: CommandCategory,
  kitFileItems: CommandItem[],
  groupFileItems: CommandItem[],
  briefDocumentItems: CommandItem[],
  textDocumentItems: CommandItem[],
  sectionItems: CommandItem[],
  kitTemplateItems: CommandItem[],
  groupTemplateItems: CommandItem[],
  libraryItems: CommandItem[],
  recentItems: CommandItem[],
  query: string,
  skillItems: CommandItem[] = [],
): GroupedItem[] => {
  const filterItems = (items: CommandItem[]) =>
    items.filter((item) =>
      item.label.toLowerCase().includes(query.toLowerCase()),
    );

  if (selectedCategory === "recently-used") {
    return [
      {
        title: "Recently Used",
        items: filterItems(recentItems),
      },
    ];
  } else if (selectedCategory === "all-references") {
    const fileItems = [...kitFileItems, ...groupFileItems];

    const groups = [];

    if (recentItems.length > 0) {
      groups.push({
        title: "Recent",
        items: filterItems(recentItems),
      });
    }

    groups.push(
      {
        title: "Documents",
        items: filterItems([
          ...briefDocumentItems,
          ...textDocumentItems,
          ...sectionItems,
        ]).sort((a, b) => a.label.localeCompare(b.label)),
      },
      {
        title: "Knowledge",
        items: filterItems(fileItems).sort((a, b) =>
          a.label.localeCompare(b.label),
        ),
      },
      {
        title: "Templates",
        items: filterItems([...kitTemplateItems, ...groupTemplateItems]).sort(
          (a, b) => a.label.localeCompare(b.label),
        ),
      },
    );

    if (skillItems.length > 0) {
      groups.push({
        title: "Skills",
        items: filterItems(skillItems).sort((a, b) =>
          a.label.localeCompare(b.label),
        ),
      });
    }

    groups.push({
      title: "Library",
      items: filterItems(libraryItems).sort((a, b) =>
        a.label.localeCompare(b.label),
      ),
    });

    return groups;
  } else if (selectedCategory === "all-files") {
    return [
      {
        title: "Workbook",
        items: filterItems(kitFileItems).sort((a, b) =>
          a.label.localeCompare(b.label),
        ),
      },
      {
        title: "Group",
        items: filterItems(groupFileItems).sort((a, b) =>
          a.label.localeCompare(b.label),
        ),
      },
    ];
  } else if (selectedCategory === "all-documents") {
    return [
      {
        title: "Documents",
        items: filterItems([
          ...briefDocumentItems,
          ...textDocumentItems,
          ...sectionItems,
        ]).sort((a, b) => a.label.localeCompare(b.label)),
      },
    ];
  } else if (selectedCategory === "all-templates") {
    return [
      {
        title: "Templates",
        items: filterItems([...kitTemplateItems, ...groupTemplateItems]).sort(
          (a, b) => a.label.localeCompare(b.label),
        ),
      },
    ];
  } else if (selectedCategory === "all-skills") {
    return [
      {
        title: "Skills",
        items: filterItems(skillItems).sort((a, b) =>
          a.label.localeCompare(b.label),
        ),
      },
    ];
    // Safe guard for new categories
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  } else if (selectedCategory === "all-library") {
    return [
      {
        title: "Library",
        items: filterItems(libraryItems).sort((a, b) =>
          a.label.localeCompare(b.label),
        ),
      },
    ];
  }

  return [];
};

export const shouldShowGroups = (
  selectedCategory: CommandCategory,
): boolean => {
  return [
    "recently-used",
    "all-references",
    "all-files",
    "all-documents",
    "all-templates",
    "all-skills",
    "all-library",
  ].includes(selectedCategory);
};
